import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class ConfirmationModalComponent extends Vue {

    constructor() {
        super();
    }

    private downloadWithoutFiles() {
        this.$emit("downloadFiles", false);
    }

    private downloadFiles() {
        this.$emit("downloadFiles", true);
    }
}
